import React from 'react'

import placeholderImage from '../../../../assets/images/placeholder-image.png'

const BkFlowRoomDetailsCta = props => {

	const renderDetailCtas = () => {
		const { roomGroup, roomData } = props

		let roomTypeCtas = null

		if (roomData) {
			roomTypeCtas = roomData.view_extensions.room_details_cta_cards
		}

		let renderCtaData = []

		for (let ctaKey in roomTypeCtas) {
			renderCtaData.push(
				<div
					key={ 'room-details-cta-' + roomTypeCtas[ctaKey].name.replace(/\s+/g, '-').toLowerCase() + '-' + roomData.code + '-' + roomGroup }
					className="bk-flow-room__details-cta"
				>
					{ roomTypeCtas[ctaKey].uri ?
						<div className="bk-flow-room__card-image u-bg-image" style={ { backgroundImage: 'url(' +  roomTypeCtas[ctaKey].uri + ')' } }>
							<img
								className="bk-flow-room__details-cta-img u-element-hidden"
								src={ roomTypeCtas[ctaKey].uri }
								alt={ roomTypeCtas[ctaKey].name }
							/>
						</div>
					:
						<div className="bk-flow-enhancements__card-image u-bg-image" style={ { backgroundImage: 'url(' +  placeholderImage + ')' } }>
							<img
								className="bk-flow-room__details-cta-img u-element-hidden"
								src={ placeholderImage }
								alt={ roomTypeCtas[ctaKey].name }
							/>
						</div>
					}

					{ roomTypeCtas[ctaKey].name ?
						<h4>{ roomTypeCtas[ctaKey].name }</h4>
					:
						null
					}

					{ roomTypeCtas[ctaKey].content ?
						<p>{ roomTypeCtas[ctaKey].content }</p>
					:
						null
					}
				</div>
			)
		}

		return renderCtaData
	}

	return (
		<div className="bk-flow-room__details-ctas row center-xs start-xs">
			{ renderDetailCtas() }
		</div>
	)
}


export default BkFlowRoomDetailsCta


// WEBPACK FOOTER //
// ./src/components/room/room-details/elements/BkFlowRoomDetailsCta.js